import { __cAuthService } from '@/services/client/__c.auth.service'
import { TForgotPasswordBody } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationKey: ['forgot-password'],
    mutationFn: async (body: TForgotPasswordBody) => {
      const response = await __cAuthService.forgotPassword(body)
      return response
    },
  })
}
